import { AbstractItemRenderer } from "./AbstractItemRenderer";

export class MissionEventItemRenderer extends AbstractItemRenderer<any> { }